import React from 'react';
import { FiDownload } from "react-icons/fi";
import image from '../../assets/mee.png';
import './About.css';

const About = () => {
    return (
        <div
            name="about"
            className="w-full bg-[#070716] text-white md:h-screen py-8 lg:py-0">
            <div className="text-center">
                <p className='hr-lines'><span className='ml-12 text-sm'>some info</span></p>
                <p className="text-3xl font-bold inline">
                    About Me
                </p>
            </div>
            <div className="max-w-sm lg:max-w-5xl mx-auto flex flex-col-reverse items-center justify-center h-full px-4 mt-10 lg:mt-0 md:flex-row">
                <div className='lg:w-3/5' data-aos='fade-right' >
                    {/* <h1 className="text-2xl font-bold">Frontend Developer || MERN Stack Developer</h1> */}
                    <p className='mt-4 lg:mt-0 text-justify'>Hello! My name is Shafkat Alam Saad and I enjoy creating things that live on the internet. My interest in web design and development started back in 2019. I am passionate about designing easy-to-use, user-friendly and interactive websites. I want to bring something new, effective, and creative to the web designing sector with my skills. In addition to my knowledge base, I actively seek out new technologies and stay up-to-date on industry trends and advancements. This has allowed me to stay ahead of the curve and deliver exceptional work.</p>
                    <div className='mt-6 w-3/5 mx-auto lg:w-full'>
                        <a href='https://drive.google.com/file/d/1TqqcEndMsUmAgrt-inM5xr2YqNR8w--a/view?usp=sharing'
                            smooth={true}
                            duration={500}
                            target='_blank'
                            rel="noreferrer"
                            className="group w-fit text-white px-6 py-3 my-2 flex items-center justify-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer">
                            Download CV
                            <span className="group-hover:rotate-90 duration-300">
                                <FiDownload size={25} className="ml-1" />
                            </span>
                        </a>
                    </div>
                </div>
                <div className="flex flex-col justify-center h-full lg:w-2/5 lg:mb-10 lg:ml-32" data-aos='fade-left'>

                    <div className="rounded-full">
                        <img src={image} alt='' />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default About;